<template>
<div class="chapter">
<div class="inner_page">
<p class="ach">B<span class="small">OOKS BY</span> D<span class="small">OROTHY</span> G<span class="small">ARLOCK</span></p>
<p class="acl"><em>After the Parade</em></p>
<p class="acl"><em>Almost Eden</em></p>
<p class="acl"><em>Annie Lash</em></p>
<p class="acl"><em>Dreamkeepers</em></p>
<p class="acl"><em>Dream River</em></p>
<p class="acl"><em>The Edge of Town</em></p>
<p class="acl"><em>Forever Victoria</em></p>
<p class="acl"><em>A Gentle Giving</em></p>
<p class="acl"><em>Glorious Dawn</em></p>
<p class="acl"><em>High on a Hill</em></p>
<p class="acl"><em>Homeplace</em></p>
<p class="acl"><em>Hope’s Highway</em></p>
<p class="acl"><em>Larkspur</em></p>
<p class="acl"><em>Leaving Whiskey Bend</em></p>
<p class="acl"><em>The Listening Sky</em></p>
<p class="acl"><em>Lonesome River</em></p>
<p class="acl"><em>Love and Cherish</em></p>
<p class="acl"><em>Loveseekers</em></p>
<p class="acl"><em>Midnight Blue</em></p>
<p class="acl"><em>More than Memory</em></p>
<p class="acl"><em>Mother Road</em></p>
<p class="acl"><em>Nightrose</em></p>
<p class="acl"><em>On Tall Pine Lake</em></p>
<p class="acl"><em>A Place Called Rainwater</em></p>
<p class="acl"><em>Promisegivers</em></p>
<p class="acl"><em>Restless Wind</em></p>
<p class="acl"><em>Ribbon in the Sky</em></p>
<p class="acl"><em>River Rising</em></p>
<p class="acl"><em>River of Tomorrow</em></p>
<p class="acl"><em>The Searching Hearts</em></p>
<p class="acl"><em>Sins of Summer</em></p>
<p class="acl"><em>Song of the Road</em></p>
<p class="acl"><em>Sweetwater</em></p>
<p class="acl"><em>Tenderness</em></p>
<p class="acl"><em>This Loving Land</em></p>
<p class="acl"><em>Train from Marietta</em></p>
<p class="acl"><em>Wayward Wind</em></p>
<p class="acl"><em>A Week from Sunday</em></p>
<p class="acl"><em>Wild Sweet Wilderness</em></p>
<p class="acl"><em>Will You Still Be Mine?</em></p>
<p class="acl"><em>Wind of Promise</em></p>
<p class="acl"><em>Wishmakers</em></p>
<p class="acl"><em>With Heart</em></p>
<p class="acl"><em>With Hope</em></p>
<p class="acl"><em>With Song</em></p>
<p class="acl"><em>Yesteryear</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MoonLookedDown_adca-1.vue?3ce7e444